/**
 * Custom event dispatched when any API request fails (e.g. CORS, network).
 * ErrorHandler listens and triggers a health refetch to detect maintenance (503).
 */
export const HEALTH_CHECK_TRIGGER_EVENT = "rivetai:trigger-health-check";

/**
 * Coalesce window for failure-driven /health probes. A burst of failed API
 * requests within this window collapses to a single /health probe.
 */
export const HEALTH_TRIGGER_DEBOUNCE_MS = 10_000;

/**
 * How long the browser must stay offline before the app shows the offline
 * screen. Most drops (Wi-Fi roaming, VPN reconnects) last a few seconds; the
 * median in PostHog was 3.3s, and each one blanked the whole app.
 */
export const OFFLINE_GRACE_MS = 4_000;

/** Base interval for active polling while the backend is known to be down. */
export const HEALTH_DOWN_POLL_BASE_MS = 15_000;

/** Maximum interval for active polling while the backend is known to be down (exponential backoff cap). */
export const HEALTH_DOWN_POLL_MAX_MS = 60_000;

/** Failure count above which we consider the app "stuck" loading (for detectLoadingStuck). */
export const LOADING_STUCK_FAILURE_THRESHOLD = 3;

/**
 * Shared retry cooldown constants for auth-maintenance "Check again"
 * (not used for global error-boundary / connectivity Try Again).
 */
export const RETRY_COOLDOWN_BASE_SECONDS = 5;
export const RETRY_COOLDOWN_MAX_SECONDS = 300;
